import { Directive, ElementRef, HostListener, Injector, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';

@Directive({
  selector: 'input, ion-input, textarea, ion-textarea'
})
export class TextFieldCharRestrictDirective {
  @Input() skipTextCharRestrict: any;

  constructor(
    private el: ElementRef,
    private commonService: CommonService,
    private injector: Injector
  ) { }

  @HostListener('input', ['$event'])
  @HostListener('ionInput', ['$event'])
  onInput(event: any) {
    if (this.shouldSkip()) {
      return;
    }
    const input = this.getInputElement(event);
    if (!input) {
      return;
    }
    const current = input.value == null ? '' : String(input.value);
    const sanitized = this.commonService.sanitizeTextFieldValue(current);
    if (sanitized === current) {
      return;
    }
    input.value = sanitized;
    if (this.el.nativeElement !== input && this.el.nativeElement.value !== undefined) {
      this.el.nativeElement.value = sanitized;
    }
    const ngControl = this.injector.get(NgControl, null);
    if (ngControl && ngControl.control) {
      ngControl.control.setValue(sanitized, { emitEvent: false });
    }
  }

  private shouldSkip(): boolean {
    if (!this.commonService.isTextFieldSpecialCharRestrictEnabled()) {
      return true;
    }
    if (this.skipTextCharRestrict === '' || this.skipTextCharRestrict === true || this.skipTextCharRestrict === 'true') {
      return true;
    }
    const host = this.el.nativeElement;
    if (!host) {
      return true;
    }
    if (host.hasAttribute && (
      host.hasAttribute('skipTextCharRestrict') ||
      host.hasAttribute('readonly') ||
      host.hasAttribute('matDatepicker') ||
      host.hasAttribute('numbersOnly') ||
      host.hasAttribute('desimalnumbersOnly') ||
      host.hasAttribute('emailPatter') ||
      host.hasAttribute('numbersSpacesOnly') ||
      host.hasAttribute('alphaNumeric') ||
      host.hasAttribute('alphaNumericSpace') ||
      host.hasAttribute('alphabets') ||
      host.hasAttribute('alphabetsChar') ||
      host.hasAttribute('specialCharecters')
    )) {
      return true;
    }
    const tag = (host.tagName || '').toUpperCase();
    if (tag === 'TEXTAREA' || tag === 'ION-TEXTAREA') {
      return false;
    }
    const type = ((host.getAttribute && host.getAttribute('type')) || host.type || 'text').toLowerCase();
    return ['password', 'email', 'number', 'tel', 'date', 'datetime-local', 'month', 'time', 'week',
      'hidden', 'file', 'checkbox', 'radio', 'range', 'color', 'button', 'submit', 'reset', 'image'
    ].indexOf(type) !== -1;
  }

  private getInputElement(event: any): HTMLInputElement {
    const eventTarget = event && (event.target || (event.detail && event.detail.target));
    if (eventTarget && eventTarget.value !== undefined && eventTarget.tagName !== 'ION-INPUT' && eventTarget.tagName !== 'ION-TEXTAREA') {
      return eventTarget;
    }
    const host = this.el.nativeElement;
    if (host && host.querySelector) {
      if (host.tagName === 'ION-INPUT') {
        const innerInput = host.querySelector('input');
        if (innerInput) {
          return innerInput;
        }
      }
      if (host.tagName === 'ION-TEXTAREA') {
        const innerTextarea = host.querySelector('textarea');
        if (innerTextarea) {
          return innerTextarea;
        }
      }
    }
    return host;
  }
}
